import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const viewPages = require.context('../view', true, /.vue/); //自动导入查询页面
const publicPages = require.context('../public-view', true, /.vue/); //自动导入公共页面
const routerArray = [];
const paramsView = 'Secure';
autogenerate(viewPages);
autogenerate(publicPages);
function autogenerate(pages){
  pages.keys().forEach((key)=>{
    const sindex = key.indexOf('/')+1;
    const lindex = key.lastIndexOf('.');
    const name = key.substring(sindex,lindex);
    routerArray.push({
      path: `/${name !== 'Transition'?name:''}${paramsView.indexOf(name)!=-1?'/:id':''}`,
      name: name,
      component: pages(key).default
    })
  })
}

export default new Router({
  routes: [
    ...routerArray
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js